import React from 'react';
import useNCZICommandProcess from '../../Hooks/useNCZICommandProcess';
import NCZICommandResult from '../NCZICommandResult/NCZICommandResult';
import {
	PatientConsentType,
	WritePatientConsent,
} from '../../Commands/WritePatientConsent';
import moment from 'moment-timezone';
import useTranslation from '../../../../Hooks/useTranslation';
import Button from '../../../../Components/Button/Button';
import Text from '../../../../Components/Base/Text/Text';

// @ts-ignore
import styles from './PatientConsent.module.scss';

interface Props {
	onClose?: (needReload: boolean) => void;
	patientIdentifier: string;
	consentType: PatientConsentType;
}

const PatientConsentModalContent: React.FC<Props> = props => {
	const { onClose, patientIdentifier, consentType } = props;
	const { processingCommandId, processCommand, isProcessing } =
		useNCZICommandProcess({
			onFinish: () => onClose?.(true),
		});
	const { t } = useTranslation();

	const handleSubmitConsentRequest = async () => {
		const writeConsent = WritePatientConsent({
			patientCode: patientIdentifier || '',
			withPatientPresence: true,
			type: consentType,
			validFrom: moment().format(),
		});

		await processCommand(writeConsent);
	};

	if (isProcessing && processingCommandId) {
		return <NCZICommandResult commandId={processingCommandId} />;
	}

	return (
		<div className={styles.wrapper}>
			<Text tx='nczi.patientPresenceConfirmation.modalText' />
			<div className='mt-4'>
				<Button
					className={styles.button}
					onClick={handleSubmitConsentRequest}
					title={'nczi.patientPresenceConfirmation.actionButton'}
				/>
			</div>
		</div>
	);
};

export default PatientConsentModalContent;
